var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({ref:"wrapper",staticClass:"fe-overflow-hidden",class:[
    {
      'fe-relative': _vm.$slots.default,
      'fe-bg-cover fe-bg-center': _vm.placeholder !== 'none',
    },
    _vm.className,
  ],style:({
    backgroundImage: _vm.placeholder !== 'none' ? `url(${_vm.placeholder})` : null,
  })},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.showImage)?_c('img',{class:['fe-w-full fe-h-full', _vm.imgClassName],attrs:{"src":_vm.src,"alt":_vm.alt,"loading":_vm.supportsLazyLoading ? 'lazy' : undefined}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }